import { ChevronRight, Inbox } from 'lucide-react';
import type { SavedProposalDoc } from '../ProposalsModal';
import { STATUS_COLORS, STATUS_LABELS, formatFullTL, formatRelativeDay, type ProposalStatus } from './metrics';

export function RecentProposals({
  items, now, onOpen,
}: {
  items: SavedProposalDoc[];
  now: Date;
  onOpen: (p: SavedProposalDoc) => void;
}) {
  if (items.length === 0) {
    return (
      <div className="px-5 py-10 flex flex-col items-center text-center gap-2">
        <div className="w-10 h-10 rounded-full bg-stone-100 text-stone-400 flex items-center justify-center">
          <Inbox className="w-5 h-5" />
        </div>
        <p className="text-xs font-bold text-stone-700">Kayıtlı teklif yok</p>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-stone-100">
      {items.map(p => {
        const status = (p.status || 'draft') as ProposalStatus;
        const unitCount = p.units?.reduce((s, u) => s + (u.quantity || 0), 0) || 0;
        return (
          <li key={p.id}>
            <button
              type="button"
              onClick={() => onOpen(p)}
              className="w-full text-left px-5 py-3 flex items-center gap-3 hover:bg-stone-50 transition-colors group"
              title="Teklifi aç"
            >
              <span className={`w-2 h-2 rounded-full shrink-0 ${STATUS_COLORS[status]}`} title={STATUS_LABELS[status]} />

              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-1.5">
                  <span className="text-xs font-semibold text-stone-900 truncate">
                    {p.clientName || p.client?.clientName || 'İsimsiz Müşteri'}
                  </span>
                  {p.proposalType === 'bulk' && (
                    <span className="shrink-0 px-2 py-0.5 rounded bg-brand-50 text-brand-700 text-[9px] font-semibold uppercase tracking-wider border border-brand-200/50">
                      Toplu{unitCount ? ` · ${unitCount} Daire` : ''}
                    </span>
                  )}
                </span>
                <span className="mt-0.5 block text-[10px] font-medium uppercase tracking-wider text-stone-400">
                  {STATUS_LABELS[status]} · {formatRelativeDay(p.updatedAt || p.createdAt, now)}
                </span>
              </span>

              <span className="shrink-0 text-xs font-semibold text-stone-900 tabular-nums">
                {formatFullTL(p.totalAmount || 0)}
              </span>
              <ChevronRight className="w-4 h-4 text-stone-300 group-hover:text-stone-500 shrink-0 transition-colors" />
            </button>
          </li>
        );
      })}
    </ul>
  );
}
